import * as React from 'react';
import clsx from 'clsx';

import { TwitterShareButton } from 'components/Sns/TwitterShareButton';
import { LineShareButton } from 'components/Sns/LineShareButton';
import { FacebookShareButton } from 'components/Sns/FacebookShareButton';

import { BookingWidgetThemeContext } from 'contexts/BookingWidgetThemeContext';
import { getThemeCssOverride } from 'components/Themes';

interface Props {
  url: string;
  locale: string;
  productName: string;
  className?: string;
}

export const ShareButtons = ({ className, url, productName, locale }: Props) => {
  const bookingWidgetTheme = React.useContext(BookingWidgetThemeContext);

  return (
    <div className={clsx('c-sns', className, getThemeCssOverride(bookingWidgetTheme, 'c-sns'))}>
      <TwitterShareButton url={url} text={productName} locale={locale} size={'small'} />
      <FacebookShareButton url={url} locale={locale} size={'small'} />
      <LineShareButton url={url} locale={locale} size={'small'} />
    </div>
  );
};
